import _ from 'lodash'
import HeaderCell from './header-cell'
import TableStack from './table-stack'
import $ from 'jquery'
import * as d3 from 'd3-selection'
import ReportConstants from 'scoreboard/reports/report-constants'
const { REPEAT_BY_TOP_POSITION } = ReportConstants

/**
 * Encapsulates all the behavior and logic related to non breakdown stack
 */
class SingleColumnStack extends TableStack {

	constructor(index, columnAttributes, opts = {}) {
		super(index, columnAttributes, opts)

		this._headerCell = new HeaderCell(this, columnAttributes, this.options)
		this.setRow([this._headerCell], 0)

		if (this.dataExtractor) {
			this.setCellFormatters([
				this.defaultCellFormatter(this.dataExtractor, this._headerCell)
			])
		}

		//the drag avatar for simple stacks is always the stack itself
		this._avatarData = [this]
	}

	bindStackBodyDomNode(td) {
		super.bindStackBodyDomNode(td);
		d3.select(td).on('click',(e) => {
			this.emit('selectCell', this, td)
			e.stopPropagation()
		})
	}

	select(state = null, targetCell, targetDomNode, opts = {}) {
		let selected = super.select(state, targetCell, targetDomNode, opts)
		let selectedNodes = $(this.domNodes())
		let classes = ['is-selected']
		selectedNodes.closest('.table').toggleClass('has-selected-stack', selected)
		selectedNodes.toggleClass(classes, selected)
		selectedNodes.toggleClass('primary', false)

		if (selected && targetDomNode) {
			//https://github.com/SpiderStrategies/Scoreboard/issues/27402#issuecomment-877538953
			let groupIndexKey = $(targetDomNode).closest('tbody').data('group-index-key')
			$(`tbody[data-group-index-key="${groupIndexKey}"] td.is-selected`).toggleClass('primary', true)
		}

		if (_.get(targetCell, 'editable')) {
			selectedNodes.first().toggleClass(['is-draggable', 'top'], true)
		}
	}

	allowDrop(dragCell, targetCell, zone) {
		if (dragCell.tableStack == targetCell.tableStack) {
			return false
		}
		const onEdge = (targetCell.first && zone.left) ||
			(targetCell.last && !zone.left)
		if (!_.isNil(dragCell.column.get('groupingId')) &&
			!_.isNil(targetCell.tableStack.repeatBy)) {
			// #41535 don't allow dragging grouped columns into repeatBy stacks
			// #56835 but allow dropping on either side of repeatBy stacks
			return !!(targetCell.position === REPEAT_BY_TOP_POSITION && onEdge)
		}
		let targetStack = targetCell.stack
		if (targetStack.isAdvancedLayoutStack()) {
			//can't move into advanced layout, but can drop the left/right of the
			//first/last cells
			return onEdge
		}
		return true
	}

	drag(dragCell, enable) {
		this._isDragging = enable
		let domNodes = this.domNodes()
		$(domNodes).toggleClass('is-being-dragged', enable)
		if (enable) {
			this.emit('avatar', this._avatarData, {firstDragNode: domNodes[0]})
		}
	}

	accept(args) {
		let {zone, enter} = args
		let position = zone.left ? 'left' : 'right'
		$(this.headerDomNodes()).toggleClass('drop-arrow', enter)
		$(this.domNodes()).toggleClass(`droppable ${position} drop-line-vertical`, enter)
	}

	/**
	 * Adds the dom node to the list of nodes that define the stack header, which
	 * are used to bind events to
	 */
	bindStackHeaderDomNode(node) {
		this._headerCell.addDomNode(node)
	}

	/**
	 * Return the model representing the header cell of this stack
	 * @return {HeaderCell}
	 */
	headerCell() {
		return this._headerCell
	}
}

export default SingleColumnStack

SingleColumnStack.__filename__ = 'reports/common/table/single-column-stack.js'
